import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-23c3f480"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Mes contrats", -1))
const _hoisted_2 = { class: "mt-5 rounded-2 overflow-hidden d-flex flex-column bg-white px-3 py-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "m-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Renouveller", -1))
const _hoisted_6 = {
  key: 0,
  id: "loader-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_table = _resolveComponent("b-table")!
  const _component_b_pagination = _resolveComponent("b-pagination")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_b_table, {
          "head-variant": "light",
          fields: _ctx.fields,
          "current-page": _ctx.currentPage,
          id: "my-table",
          "tbody-transition-props": _ctx.transProps,
          "sticky-header": "",
          hover: "",
          items: _ctx.contrats
        }, {
          "cell(photo)": _withCtx((data) => [
            _createElementVNode("img", {
              src: data.item.photo,
              alt: "",
              style: {"width":"13%","height":"13%"},
              class: "img-fluid"
            }, null, 8, _hoisted_3),
            _createElementVNode("span", _hoisted_4, _toDisplayString(data.item.label), 1)
          ]),
          "cell(id)": _withCtx((data) => [
            _createVNode(_component_b_button, {
              class: "mr-2",
              variant: "info",
              style: {"height":"padding: 5px"},
              id: data.item.id
            }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(data.item.primeTTC), 1)
              ], undefined, true),
              _: 2
            }, 1032, ["id"]),
            _createTextVNode(" " + _toDisplayString(data.id) + " ", 1)
          ]),
          _: 1
        }, 8, ["fields", "current-page", "tbody-transition-props", "items"]),
        _createVNode(_component_b_pagination, {
          class: "align-self-end mt-3",
          modelValue: _ctx.currentPage,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
          "total-rows": _ctx.rows(),
          "per-page": _ctx.perPage,
          "aria-controls": "my-table"
        }, null, 8, ["modelValue", "total-rows", "per-page"])
      ]),
      (_ctx.isloading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Loading)
          ]))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}